import { ArrowUpRight } from "@phosphor-icons/react";
import { Reveal } from "../Reveal";
import { useLanguage } from "../../context/LanguageContext";

export const fmtDate = (iso, lang) =>
  new Intl.DateTimeFormat(lang === "id" ? "id-ID" : "en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date(iso));

export const Insights = () => {
  const { t, lang } = useLanguage();

  return (
    <section id="insights" data-testid="insights-section" className="py-24 md:py-36 border-t border-black/10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-brand-red mb-6">
            — {t.insights.label}
          </p>
          <div className="flex flex-wrap items-end justify-between gap-6 mb-14 md:mb-20">
            <h2 className="font-cabinet font-black tracking-tight text-2xl sm:text-3xl lg:text-5xl leading-tight max-w-2xl">
              {t.insights.title}
            </h2>
            <a
              data-testid="insights-view-all"
              href="/artikel"
              className="group flex items-center gap-2 text-sm font-bold tracking-wide text-black/60 hover:text-brand-green transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-brand-green"
            >
              {t.insights.more}
              <ArrowUpRight size={16} weight="bold" className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {t.articles.map((a, i) => (
            <Reveal key={a.slug} delay={0.07 * i}>
              <a
                data-testid={`article-card-${a.slug}`}
                href={`/artikel/${a.slug}`}
                className="group flex flex-col h-full bg-white border border-black/10 p-7 md:p-9 min-h-[260px] transition-[transform,border-color] duration-500 hover:-translate-y-1.5 hover:border-black/40 focus:outline-none focus:ring-2 focus:ring-brand-green"
              >
                <div className="flex items-center gap-3 mb-6">
                  <span className="bg-brand-green/10 text-brand-green px-3 py-1 text-[10px] font-bold tracking-[0.15em] uppercase">
                    {a.category}
                  </span>
                  <span className="text-xs text-black/40">
                    {fmtDate(a.date, lang)} · {a.readTime} {t.insights.minRead}
                  </span>
                </div>
                <h3 className="font-cabinet font-bold text-xl tracking-tight leading-snug mb-4 group-hover:text-brand-green transition-colors duration-300">
                  {a.title}
                </h3>
                <p className="text-sm leading-relaxed text-black/55 line-clamp-3 mb-6">{a.excerpt}</p>
                <span className="mt-auto flex items-center gap-2 text-xs font-bold tracking-[0.15em] uppercase text-black/45 group-hover:text-brand-red transition-colors duration-300">
                  {t.insights.readCta}
                  <ArrowUpRight size={14} weight="bold" className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
